import React, { useEffect, useRef } from "react";
import { HiMiniEllipsisVertical } from "react-icons/hi2";
import { ActionButtonContainer } from "../../styled/setting";
import { status } from "../../function/store";

const ActionButtons = ({
  context,
  setContext,
  item,
  highlight = false,
  buttons = [],
  changeStatus = null,
  isContext = true,
  parentId = null,
}) => {
  const menuRef = useRef();

  const isActive =
    context?.id === item.id &&
    (highlight ? context?.type === "group" : context?.type === "option") &&
    (highlight || context?.parentId === parentId);

  const openContext = (menuType) => {
    setContext({
      id: item.id,
      parentId,
      type: highlight ? "group" : "option",
      menu: menuType,
      highlight,
    });

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setContext(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  };

  return (
    <ActionButtonContainer className={highlight ? " highlight" : ""}>
      {item?.status && (
        <button type="button" onClick={() => openContext("status")} className="status">
          {status[item.status]}
        </button>
      )}
      {isContext ? (
        <button type="button" onClick={() => openContext("actions")} className="actions">
          <HiMiniEllipsisVertical />
        </button>
      ) : (
        buttons.map(({ label, onClick, icon: Icon }, index) => (
          <button key={index} type="button" onClick={onClick} className="actions">
            {Icon ? <Icon /> : label}
          </button>
        ))
      )}

      {isActive && (
        <ul className={`context-${context?.menu} activeContext`} ref={menuRef}>
          {context?.menu === "actions"
            ? buttons.map(({ label, onClick, isActive }, index) => (
                <li key={label} className={isActive ? "active" : "inactive"} onClick={onClick}>
                  {label}
                </li>
              ))
            : Object.entries(status).map(([key, value]) => (
                <li
                  key={key}
                  onClick={() => changeStatus?.(key, item)}
                  className={item?.status === key ? "active" : "inactive"}>
                  {value}
                </li>
              ))}
        </ul>
      )}
    </ActionButtonContainer>
  );
};

export default ActionButtons;
